import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useMatch } from 'react-router-dom';
import { logout } from '../../store/actions/auth';
import { useSelector, useDispatch } from 'react-redux';
// nodejs library that concatenates strings
import classnames from 'classnames';
// JavaScript plugin that hides or shows a component based on your scroll
import Headroom from 'headroom.js';
// reactstrap components
import {
	Collapse,
	NavbarBrand,
	Navbar,
	Nav,
	NavItem,
	NavLink,
	Button,
	Container,
} from 'reactstrap';

// core components

function NavbarMain({ businessName }) {
	//redux store
	const dispatch = useDispatch();
	const currentUser = useSelector((state) => state.currentUser.user);
	//finding the current location
	const pageBusinessPublic = useMatch('/business-page/:businessId');
	// const pageProductPublic = useMatch('/product-page/:productId');
	const pageSignup = useMatch('/signup');
	const pageSignin = useMatch('/signin');
	const pagePricing = useMatch('/pricing');
	//Styling
	const [navbarColor, setNavbarColor] = useState('navbar-transparent');
	const [bodyClick, setBodyClick] = useState(false);
	const [collapseOpen, setCollapseOpen] = useState(false);
	useEffect(() => {
		let headroom = new Headroom(document.getElementById('navbar-main'));
		// initialise
		headroom.init();

		const updateNavbarColor = () => {
			if (
				document.documentElement.scrollTop > 499 ||
				document.body.scrollTop > 499
			) {
				setNavbarColor('default');
			} else if (
				document.documentElement.scrollTop < 500 ||
				document.body.scrollTop < 500
			) {
				setNavbarColor('navbar-transparent');
			}
		};
		window.addEventListener('scroll', updateNavbarColor);
		return function cleanup() {
			window.removeEventListener('scroll', updateNavbarColor);
		};
	});

	return (
		<>
			{currentUser.id ? (
				<div>
					{bodyClick ? (
						<div
							id='bodyClick'
							onClick={() => {
								document.documentElement.classList.toggle('nav-open');
								setBodyClick(false);
								setCollapseOpen(false);
							}}
						/>
					) : null}
					<Navbar
						className={classnames('fixed-top', navbarColor)}
						color='dark'
						id='navbar-main'
						expand='lg'>
						<Container>
							<div className='navbar-translate'>
								<NavbarBrand id='navbar-brand' to='/index' tag={Link}>
									{currentUser.businessName}
								</NavbarBrand>

								<button
									className='navbar-toggler'
									id='navigation'
									type='button'
									onClick={() => {
										document.documentElement.classList.toggle('nav-open');
										setBodyClick(true);
										setCollapseOpen(true);
									}}>
									<span className='navbar-toggler-bar bar1'></span>
									<span className='navbar-toggler-bar bar2'></span>
									<span className='navbar-toggler-bar bar3'></span>
								</button>
							</div>
							<Collapse navbar isOpen={collapseOpen}>
								<Nav className='ml-auto' navbar>
									<NavItem>
										<Button
											onClick={() => dispatch(logout())}
											className='btn-border btn-round mr-1'
											color='success'>
											Sign out
										</Button>
									</NavItem>
								</Nav>
							</Collapse>
						</Container>
					</Navbar>
				</div>
			) : (
				<div>
					{bodyClick ? (
						<div
							id='bodyClick'
							onClick={() => {
								document.documentElement.classList.toggle('nav-open');
								setBodyClick(false);
								setCollapseOpen(false);
							}}
						/>
					) : null}
					<Navbar
						className={classnames('fixed-top', navbarColor)}
						id='navbar-main'
						expand='lg'>
						<Container>
							<div className='navbar-translate'>
								{pageBusinessPublic === null ? (
									<NavbarBrand id='navbar-brand' to='/index' tag={Link}>
										Weciny
									</NavbarBrand>
								) : (
									<NavbarBrand id='navbar-brand' to='/index' tag={Link}>
										{businessName}
									</NavbarBrand>
								)}

								<button
									className='navbar-toggler'
									id='navigation'
									type='button'
									onClick={() => {
										document.documentElement.classList.toggle('nav-open');
										setBodyClick(true);
										setCollapseOpen(true);
									}}>
									<span className='navbar-toggler-bar bar1'></span>
									<span className='navbar-toggler-bar bar2'></span>
									<span className='navbar-toggler-bar bar3'></span>
								</button>
							</div>
							<Collapse navbar isOpen={collapseOpen}>
								<Nav className='ml-auto' navbar>
									{' '}
									{pageSignup === null && (
										<NavItem>
											<Button
												className=' btn-round mr-1 btn-CreateStore'
												color='success'
												href='/signup'>
												Create your online store
											</Button>
										</NavItem>
									)}
									{pagePricing === null && (
										<NavItem>
											<NavLink href='/pricing'>Pricing</NavLink>
										</NavItem>
									)}
									{pageSignin === null && (
										<NavItem>
											<NavLink href='/signin'>Sign in</NavLink>
										</NavItem>
									)}
								</Nav>
							</Collapse>
						</Container>
					</Navbar>
				</div>
			)}
		</>
	);
}

export default NavbarMain;
